<template>
  <div
    id="mobile-banner"
    class="d-md-none d-flex align-items-end"
    :style="{ backgroundImage: `url(${img[(5 * Math.random()) | 0]})` }"
  >
    <div class="container">
      <div class="mobile-h1" style="color: #fff">
        {{ pageTitles[$route.name] }}
      </div>
    </div>
  </div>
</template>

<script>
import { pageTitles } from '@/assets/js/menu';

import y1 from '@/assets/img/y1.png';
import y2 from '@/assets/img/y2.png';
import y3 from '@/assets/img/y3.png';
import y4 from '@/assets/img/y4.png';
import y5 from '@/assets/img/y5.png';

export default {
  name: 'MobileBanner',
  components: {
  },
  data() {
    return {
      pageTitles,
      img: [y1, y2, y3, y4, y5],
    };
  },
};
</script>
<style lang="stylus" scoped>
#mobile-banner
  width: 100%;
  height: 80vw;
  background-size: cover;
  padding: 30px;
</style>
